import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';

import createHistory from 'history/createBrowserHistory';
import rootReducer from './../reducers';

export const history = createHistory();

const initialState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
    if (typeof window === 'object') {
        const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;
        if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
            enhancers.push(__REDUX_DEVTOOLS_EXTENSION_COMPOSE__());
        }
    }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);
const store = createStore(rootReducer, initialState, composedEnhancers);

export default store;



// WEBPACK FOOTER //
// ./src/configuration/store.js